import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/hotline.png'
import _imports_1 from '@/assets/img/tel.png'


const _withScopeId = n => (_pushScopeId("data-v-1c2ed9a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "closed"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "button-icon",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("投")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("诉")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode("电")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("话 ")
const _hoisted_11 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "open"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "tel-icon",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "button-icon",
  src: _imports_0,
  alt: ""
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.phoneNumber)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["complaint-button", { 'hovered': _ctx.isHovered }]),
        onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleHover(true))),
        onMouseout: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleHover(false)))
      }, [
        (!_ctx.isHovered)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_11))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _hoisted_13,
              _createTextVNode(" " + _toDisplayString(_ctx.phoneNumber) + " ", 1),
              _hoisted_14
            ]))
      ], 34))
    : _createCommentVNode("", true)
}